import {createSlice} from "@reduxjs/toolkit";

const initialPendingRecallingResourcesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  loadData: null,
  pendingRecallingResourceForEdit: undefined,
  listApplications: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const pendingRecallingResourcesSlice = createSlice({
  name: "pendingRecallingResources",
  initialState: initialPendingRecallingResourcesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    pendingRecallingResourcesLoadedData: (state, action) => {
      state.error = null;
      state.loadData = action.payload.loadData;
      state.actionsLoading = false;
    },
    // getPendingRecallingResourceById
    pendingRecallingResourceFetched: (state, action) => {
      state.actionsLoading = false;
      state.pendingRecallingResourceForEdit = action.payload.pendingRecallingResourceForEdit;
      state.error = null;
    },
    listApplicationsFetched: (state, action) => {
      state.actionsLoading = false;
      state.listApplications = action.payload.list;
      state.listLoading = false;
      state.error = null;
    },
    listApplicationsReclaimed: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // findPendingRecallingResources
    pendingRecallingResourcesFetched: (state, action) => {
      const { totalCount, list } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = list;
      state.totalCount = totalCount;
    },
    // createPendingRecallingResource
    pendingRecallingResourceCreated: (state, action) => {
      state.ewactionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.pendingRecallingResource);
    },
    // updatePendingRecallingResource
    pendingRecallingResourceUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.pendingRecallingResource.id) {
          return action.payload.pendingRecallingResource;
        }
        return entity;
      });
    },
    // deletePendingRecallingResource
    pendingRecallingResourceDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletePendingRecallingResources
    pendingRecallingResourcesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    pendingRecallingResourceApproved: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    pendingRecallingResourceRejected: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // pendingRecallingResourcesUpdateState
    pendingRecallingResourcesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
